<script setup lang="ts">
</script>

<template>
  <VCard class="suggestion-card-skeleton d-flex flex-column gap-4 pa-4">
    <div class="d-flex flex-column">
      <VSkeletonLoader
        type="chip"
        width="8rem"
      />
      <VSkeletonLoader
        class="mt-5"
        type="heading"
        width="70%"
      />
    </div>

    <VSkeletonLoader
      type="text"
      width="85%"
    />

    <div class="d-flex align-center gap-2">
      <VSkeletonLoader type="avatar" />
      <VSkeletonLoader
        type="text"
        width="12rem"
      />
    </div>

    <div class="d-flex justify-space-between align-center">
      <div class="d-flex align-center gap-4">
        <VSkeletonLoader
          type="text"
          width="6rem"
        />
        <VSkeletonLoader
          type="text"
          width="8rem"
        />
      </div>
      <div class="d-flex align-center gap-1">
        <VSkeletonLoader
          type="text"
          width="3rem"
        />
        <VSkeletonLoader
          type="text"
          width="3rem"
        />
      </div>
    </div>
  </VCard>
</template>

<style scoped lang="scss">
.suggestion-card-skeleton {
  :deep(.v-skeleton-loader) {
    background: transparent;
  }

  /* Vuetify: аватар 48px + margin, иначе круг обрезается «Pac-Man» */
  :deep(.v-skeleton-loader__avatar) {
    width: 32px;
    height: 32px;
    min-width: 32px;
    min-height: 32px;
    max-width: 32px;
    max-height: 32px;
    margin: 0;
  }

  :deep(.v-skeleton-loader__chip),
  :deep(.v-skeleton-loader__heading),
  :deep(.v-skeleton-loader__text) {
    margin: 0;
  }
}
</style>
